import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/hy-logo.png";

const Navbar = ({ isOpen, onClose }) => {
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("username");
    window.location.href = "/";
  };

  const isAdmin = (localStorage.getItem("username") || "") === "admin";

  return (
    <nav className={`navbar ${isOpen ? "open" : "hidden"}`}>
      <div>
        {/* 🔹 navbar-top 안의 햄버거는 제거 */}
        <div className="navbar-top" />
        <div className="logo-container">
          <img src={logo} alt="로고" className="logo" />
        </div>
      </div>

      <ul className="nav-menu">
        <li>
          <Link to="/dashboard" onClick={onClose}>
            <span className="nav-icon">📊</span>
            <span className="nav-label">현황</span>
          </Link>
        </li>
        <li>
          <Link to="/inventory" onClick={onClose}>
            <span className="nav-icon">📦</span>
            <span className="nav-label">재고</span>
          </Link>
        </li>
        <li>
          <Link to="/stockin" onClick={onClose}>
            <span className="nav-icon">📥</span>
            <span className="nav-label">입고</span>
          </Link>
        </li>
        <li>
          <Link to="/checkout" onClick={onClose}>
            <span className="nav-icon">🏷️</span>
            <span className="nav-label">출고</span>
          </Link>
        </li>
        <li>
          <Link to="/board" onClick={onClose}>
            <span className="nav-icon">📜</span>
            <span className="nav-label">게시판</span>
          </Link>
        </li>
        {/* <li>
          <Link to="/projects" onClick={onClose}>
            <span className="nav-icon">🧩</span>
            <span className="nav-label">프로젝트</span>
          </Link>
        </li> */}
        <li>
          <Link to="/print" onClick={onClose}>
            <span className="nav-icon">🖨️</span>
            <span className="nav-label">프린트</span>
          </Link>
        </li>
        {isAdmin && (
          <li>
            <Link to="/shortcut" onClick={onClose}>
              <span className="nav-icon">⚙️</span>
              <span className="nav-label">관리자</span>
            </Link>
          </li>
        )}
      </ul>
      <div className="logout-section">
        <button type="button" className="logout-btn" onClick={handleLogout}>
          <span className="nav-icon">🚪</span>
          <span className="nav-label">로그아웃</span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
